import { fmtDate } from "../../lib/api";

const fmtTRY = (n) => new Intl.NumberFormat("tr-TR", { style: "currency", currency: "TRY", minimumFractionDigits: 2 }).format(Number(n) || 0);
import { Card } from "../ui/card";
import { Badge } from "../ui/badge";
import { Button } from "../ui/button";
import { Pencil, Trash2, Paperclip, Repeat } from "lucide-react";
import { METHOD, CENTER } from "./constants";

const Actions = ({ t, onEdit, onDelete }) => (
  <div className="flex shrink-0">
    <Button size="icon" variant="ghost" onClick={() => onEdit(t)} data-testid={`exp-edit-${t.id}`}><Pencil size={14} /></Button>
    <Button size="icon" variant="ghost" onClick={() => onDelete(t.id)} data-testid={`exp-delete-${t.id}`}><Trash2 size={14} className="text-rose-600" /></Button>
  </div>
);

export default function ExpenseList({ items, onEdit, onDelete, readOnly = false }) {
  if (!items.length) return <Card className="border-slate-200 p-10 text-center text-slate-500" data-testid="exp-empty">Kayıt yok.</Card>;
  return (
    <Card className="border-slate-200 divide-y divide-slate-100" data-testid="exp-list">
      {items.map((t) => (
        <div key={t.id} className="p-3 sm:px-4 flex items-center gap-3" data-testid={`exp-row-${t.id}`}>
          <div className="w-16 sm:w-20 shrink-0 text-xs text-slate-500">{fmtDate(t.date || t.created_at)}</div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2 flex-wrap">
              <span className="font-semibold text-sm text-slate-900">{t.category || "—"}</span>
              <Badge variant="outline" className="text-[10px]">{METHOD[t.payment_method] || t.payment_method}</Badge>
              <Badge variant="outline" className="text-[10px] hidden sm:inline-flex">{CENTER[t.cost_center] || "Genel"}</Badge>
              {t.recurring_id && <Repeat size={12} className="text-[#D97706]" />}
              {t.media?.length > 0 && <span className="text-xs text-slate-500 inline-flex items-center gap-0.5"><Paperclip size={12} />{t.media.length}</span>}
            </div>
            {t.description && <div className="text-xs text-slate-500 truncate">{t.description}</div>}
            {!readOnly && t.created_by_name && <div className="text-[11px] text-slate-400 truncate">Giren: {t.created_by_name}</div>}
          </div>
          <div className="font-bold text-rose-600 text-sm sm:text-base whitespace-nowrap" data-testid={`exp-amount-${t.id}`}>-{fmtTRY(t.amount)}</div>
          {!readOnly && <Actions t={t} onEdit={onEdit} onDelete={onDelete} />}
        </div>
      ))}
    </Card>
  );
}
